import React, { useEffect, useRef, useState } from "react";
import { useDempStore } from "src/context/stores";
import { getAllSiteMapDapByMultipleCompanyIds } from "src/api/site";
import imgTransparent from "src/assets/siteManagement/images/transparent.png";
import { PageLoading } from "src/components/ui";
import { SiteDetailBoxType4 } from "src/components/site_management/site-detail-box-type4";
import { Text } from "src/components/ui/Text";
import { IconProperties } from "src/components/site_management/site-detail-box-type4/Icon";
import DapGisMapComponent from "src/components/site_management/gis-map/dap-gis-map/DapGisMapComponent";
import { RiskSiteMap } from ".";
import clsx from "clsx";

const DapSiteMap = ({ isRiskSiteMap }) => {
  const [companyId] = useDempStore((state) => [
    state.selectedCompanies,
    state.plantId,
  ]);

  const [isLoading, setIsLoading] = useState(false);
  const divGisMapContentRef = useRef(null);
  const divSlideShowSiteCardRef = useRef(null);
  const leftDivSlideShowSiteCardRef = useRef(0);
  const leftMouseDownFirstRef = useRef(0);
  const [disableClickCard, setDisableClickCard] = useState(false);
  const disableClickCardRef = useRef(disableClickCard);
  const [listSite, setListSite] = useState([]);
  const [refCodeId, setRefCodeId] = useState("");
  const listSiteRef = useRef(listSite);
  const [focusSite, setFocusSite] = useState(null);
  const siteListContainerRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      await onSetListSite();
    };
    init();
  }, []);

  useEffect(() => {
    const func = async () => {
      if (companyId) {
        await onSetListSite();
      }
    };
    func();
  }, [companyId]);

  useEffect(() => {
    listSiteRef.current = listSite;
  }, [listSite]);

  //==============================
  async function onGetListSiteByCompanyId(param) {
    let listX = [];
    const payload = {
      company_id: [...param],
    };
    const response = await getAllSiteMapDapByMultipleCompanyIds(payload);

    if (response?.status) {
      const dataResponse = response?.data?.data;
      setRefCodeId(response?.data?.ref_id);

      for (let item of dataResponse) {
        let albumImage;
        try {
          albumImage = JSON.parse(item?.album);
        } catch {}
        let listImage = [];
        let imageSite = imgTransparent;
        let imageId = 0;
        if (Array.isArray(albumImage) && albumImage.length > 0) {
          listImage = albumImage.slice();
          const detailImage = listImage[listImage.length - 1];
        }
        if (item.main_image) {
          imageId = item.main_image;
          imageSite = item.main_image_file;
        }
        //==============================
        let detailCountOverview = {
          countBuilding: 0,
          countFloor: 0,
          countPlace: 0,
          countDevice: 0,
        };
        detailCountOverview = await onSetCountSiteOverview(
          detailCountOverview,
          item.asset,
          "building"
        );

        let detailLatLng;
        if (item?.location) {
          detailLatLng = JSON.parse(item?.location);
        } else {
          detailLatLng = { lat: 0, lon: 0 };
        }

        const detail = {
          Id: item.id,
          Name: item.name,
          Image: imageSite,
          ImageId: imageId,
          AlbumImage: listImage,
          Description: item.description,
          Location: item.address,
          Latitude: detailLatLng.lat,
          Longitude: detailLatLng.lon,
          Assets: item.asset,
          CountBuilding: detailCountOverview.countBuilding,
          CountFloor: detailCountOverview.countFloor,
          CountPlace: detailCountOverview.countPlace,
          CountDevice: detailCountOverview.countDevice,
          Active: true,
          Visible: true,
          companyId: item.company,
          plantId: item.plant_code,

          //    new data from api
          basic_info: item.basic_info,
          location: item.location,
          area_measurements: item.area_measurements,
          financial_info: item.financial_info,
          import_date: item.import_date,
          operational_status: item.operational_status,
        };
        listX.push(detail);
      }
    }
    return listX;
  }

  async function onSetCountSiteOverview(param, list, type) {
    if (type === "building" && Array.isArray(list)) {
      param.countBuilding = param.countBuilding + list.length;
    }
    for (let item of list) {
      if (Array.isArray(item.floor)) {
        param.countFloor = param.countFloor + item.floor.length;
        param = await onSetCountSiteOverview(param, item.floor, "floor");
      }
      if (Array.isArray(item.place)) {
        param.countPlace = param.countPlace + item.place.length;
        param = await onSetCountSiteOverview(param, item.place, "place");
      }
      if (Array.isArray(item.device)) {
        param.countDevice = param.countDevice + item.device.length;
        param = await onSetCountSiteOverview(param, item.device, "device");
      }
    }
    return param;
  }

  async function onSetListSite() {
    setIsLoading(true);
    //==============================
    let listX = [];
    listX = await onGetListSiteByCompanyId(companyId);
    setListSite(listX);
    //==============================
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }

  async function onSetBuildingDeviceSummary(param) {
    let SiteAllCount = param.length;
    let BuilingAllCount = 0;
    let FloorAllCount = 0;
    let DeviceAllCount = 0;
    //==============================
    let SiteViewCount = 0;
    let BuilingViewCount = 0;
    let FloorViewCount = 0;
    let DeviceViewCount = 0;
    //==============================
    for (let item of param) {
      if (item.Visible && item.Active) {
        SiteViewCount++;
        BuilingViewCount = BuilingViewCount + item.CountBuilding;
        FloorViewCount = FloorViewCount + item.CountFloor;
        DeviceViewCount = DeviceViewCount + item.CountDevice;
      }
      //==============================
      BuilingAllCount = BuilingAllCount + item.CountBuilding;
      FloorAllCount = FloorAllCount + item.CountFloor;
      DeviceAllCount = DeviceAllCount + item.CountDevice;
    }
  }
  //==============================
  function onDetectMobile() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  //   async function onMouseDownSlideShowSiteCard(param) {
  //     const wParent = divGisMapContentRef?.current?.offsetWidth;
  //     const wChild = divSlideShowSiteCardRef?.current?.offsetWidth;
  //     if (wChild < wParent) {
  //       if (divSlideShowSiteCardRef?.current) {
  //         divSlideShowSiteCardRef.current.style.left = `0px`;
  //       }
  //       return;
  //     }
  //     //==============================
  //     param.stopPropagation();
  //     //==============================
  //     const isMobile = onDetectMobile();
  //     //==============================
  //     if (!isMobile) param.preventDefault();
  //     //==============================
  //     if (divSlideShowSiteCardRef.current) {
  //       leftDivSlideShowSiteCardRef.current =
  //         divSlideShowSiteCardRef.current.offsetLeft;
  //     }
  //     if (isMobile) {
  //       const targetTouches = param.targetTouches;
  //       if (!targetTouches) return;
  //       const leftClickFirst = targetTouches[0].clientX;
  //       leftMouseDownFirstRef.current = leftClickFirst;
  //       document.ontouchend = onMouseUpSlideShowSiteCard;
  //       document.ontouchmove = onMouseMoveSlideShowSiteCard;
  //     } else {
  //       const leftClickFirst = param.clientX;
  //       leftMouseDownFirstRef.current = leftClickFirst;
  //       document.onmouseup = onMouseUpSlideShowSiteCard;
  //       document.onmousemove = onMouseMoveSlideShowSiteCard;
  //     }
  //   }

  async function onMouseUpSlideShowSiteCard(param) {
    setTimeout(() => {
      disableClickCardRef.current = false;
      setDisableClickCard(disableClickCardRef.current);
    }, 100);
    //==============================
    const isMobile = onDetectMobile();
    //==============================
    if (isMobile) {
      document.ontouchend = null;
      document.ontouchmove = null;
    } else {
      document.onmouseup = null;
      document.onmousemove = null;
    }
    //==============================
  }

  //   async function onMouseMoveSlideShowSiteCard(param) {
  //     disableClickCardRef.current = true;
  //     setDisableClickCard(disableClickCardRef.current);
  //     //==============================
  //     const isMobile = onDetectMobile();
  //     //==============================
  //     let left;
  //     if (isMobile) {
  //       const targetTouches = param.targetTouches;
  //       left = targetTouches[0].clientX;
  //     } else {
  //       param.preventDefault();
  //       left = param.clientX;
  //     }
  //     //==============================
  //     const wParent = divGisMapContentRef?.current?.offsetWidth;
  //     const wChild = divSlideShowSiteCardRef?.current?.offsetWidth;
  //     const positionLeftDiff = left - leftMouseDownFirstRef.current;
  //     let leftPosition = positionLeftDiff + leftDivSlideShowSiteCardRef?.current;
  //     if (leftPosition > 0) {
  //       leftPosition = 0;
  //     }
  //     if (wChild + leftPosition < wParent) {
  //       leftPosition = wParent - wChild;
  //     }
  //     if (divSlideShowSiteCardRef.current) {
  //       divSlideShowSiteCardRef.current.style.left = `${leftPosition}px`;
  //     }
  //     //==============================
  //   }

  //==============================

  function onClickFocusSite(param) {
    let listX = [];
    listX = JSON.parse(JSON.stringify(listSite));
    listX = listX.map((value, index) => {
      value.Visible = param.Id === value.Id ? true : false;
      return value;
    });
    setListSite(listX);
    setFocusSite(param);
    onSetBuildingDeviceSummary(listX);
  }

  function scrollToSiteItem(siteId) {
    if (!siteListContainerRef.current) return;

    const siteElements =
      siteListContainerRef.current.querySelectorAll("[data-site-id]");

    const targetElement = Array.from(siteElements).find((el) => {
      const dataSiteId = el.getAttribute("data-site-id");
      return Number(dataSiteId) === Number(siteId);
    });

    if (targetElement) {
      // Scroll to the target element with smooth animation
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }
  }

  function onSetVisibleSite(param) {
    let listX = [];
    listX = JSON.parse(JSON.stringify(listSiteRef.current));
    listX = listX.map((value, index) => {
      let model = param.find((x) => x.Id === value.Id);
      if (model) {
        value.Visible = model.Visible;
      }
      return value;
    });
    setListSite(listX);
    setFocusSite(null);
    //==============================
    onSetBuildingDeviceSummary(listX);
  }

  return (
    <div>
      {
        isLoading && <PageLoading loading={isLoading} />
        // <PopupModalLoading isOpen={isLoading} />
      }

      {/* ========== Main Map Content ========== */}
      <div className="h-[calc(100vh-145px)] flex w-full">
        {/* ========== left side of map content ========== */}
        {/* {isRiskSiteMap ? (
          <div className="grow mr-2">
            <RiskSiteMap companyId={companyId} focusSite={focusSite} />
          </div>
        ) : (
          <div
            ref={divGisMapContentRef}
            className="relative h-full mr-2 overflow-hidden rounded-lg shadow-content-box"
            style={{ width: "calc(100% - 380px)" }}
          >
            <DapGisMapComponent
              focusSite={focusSite}
              listSite={listSite}
              onChangeVisibleSite={(e) => {
                onSetVisibleSite(e);
              }}
              onMarkerClick={(siteId) => {
                const siteData = listSite.find((site) => site.Id === siteId);
                if (siteData) {
                  onClickFocusSite(siteData);
                  // Auto scroll only when clicking marker
                  setTimeout(() => {
                    scrollToSiteItem(siteId);
                  }, 300);
                }
              }}
              setIsLoading={(e) => {
                setIsLoading(e);
              }}
              // onChangeCenterMap={(e) => {
              // onSetCenterMap(e);
              // }}
            />
          </div>
        )} */}
        <div className="grow mr-2">
          <RiskSiteMap focusSite={focusSite} refCodeId={refCodeId} />
        </div>

        {/* ========== right side of detail site content ========== */}
        <div className="w-[380px] min-w-[380px] h-full border border-gray-200 rounded-lg bg-white">
          {/* <div className={`pb-1 ${onSetClassHeightBoxByType(1)}`}>
            <SiteBoxDetailType1
              type={displayType}
              listSite={listSite}
              centerMapFocus={centerMainMap}
              summary={siteOverview}
            />
          </div>
          {displayType === 3 && (
            <div className={`py-1 ${onSetClassHeightBoxByType(3)}`}>
              <SiteBoxDetailType3
                detailSite={focusSite}
                // onClickEdit={(e) => {
                //   onClickEditSite(e);
                // }}
              />
            </div>
          )}
          <div className={`pt-1 ${onSetClassHeightBoxByType(2)}`}>
            <SiteBoxDetailType2
              listSite={listSite}
              onChangeActiveSite={(e) => {
                onSetActiveSite(e);
              }}
            />
          </div> */}
          {/* Tittle site lists */}
          <div className="flex items-center gap-1 p-4 pl-5 pt-6 border-b border-gray-200">
            <IconProperties className="w-4 h-4 stroke-vekin" />
            <Text variant="semi-14" color="black">
              {`Properties (${listSite.length})`}
            </Text>
          </div>

          <div
            ref={siteListContainerRef}
            className={`h-[calc(100%-65px)] overflow-y-auto mr-1 p-3 pl-4 my-1 flex flex-col gap-3 ${clsx(
              {
                "overflow-y-auto": listSite.length > 0,
                "overflow-y-hidden": listSite.length === 0,
              }
            )}`}
          >
            {listSite?.map((value) => {
              return (
                <div key={value?.Id} data-site-id={value?.Id}>
                  <SiteDetailBoxType4
                    disable={disableClickCardRef.current}
                    detailSite={value}
                    focusSite={focusSite}
                    onClick={() => {
                      onClickFocusSite(value);
                    }}
                  />
                </div>
              );
            })}

            {listSite?.length === 0 && (
              <div className="flex flex-col gap-3">
                {Array.from({ length: 100 }).map((_, index) => (
                  <div
                    key={index}
                    className="animate-pulse bg-gray-200 h-[120px] rounded-lg"
                  ></div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DapSiteMap;
